import _ from "lodash";
import { FC, useEffect, useState } from "react";
import { Modal } from "antd";
import Markdown from "markdown-to-jsx";
import { marked } from "marked";
import DOMPurify from "dompurify";

import useCommonStore from "stores/useCommon";
import { MarkdownConfig } from "constants/markdown";

const ModalDynamicInformation: FC = ({ dataDynamicInfo }: any) => {
  const { dynamicInfoKey, isShowModalDynamicInfo, setIsShowModalDynamicInfo } =
    useCommonStore();

  const [markdownText, setMarkdownText] = useState("");

  useEffect(() => {
    const parseMarkdownText = async () => {
      const text = await marked.parse(
        _.get(dataDynamicInfo, `${dynamicInfoKey}.details`, "")
      );
      setMarkdownText(DOMPurify.sanitize(text));
    };
    parseMarkdownText();
  }, [dataDynamicInfo, dynamicInfoKey]);

  return (
    <Modal
      title={
        dynamicInfoKey ? _.get(dataDynamicInfo, `${dynamicInfoKey}.header`) : ""
      }
      open={isShowModalDynamicInfo}
      centered
      onCancel={() => setIsShowModalDynamicInfo(false)}
      onOk={() => setIsShowModalDynamicInfo(false)}
      cancelButtonProps={{ className: "hidden" }}
      width={600}
    >
      <Markdown
        options={{
          forceWrapper: true,
          wrapper: "div",
          overrides: MarkdownConfig,
        }}
      >
        {markdownText}
      </Markdown>
    </Modal>
  );
};

export default ModalDynamicInformation;
